module.exports = __webpack_public_path__ + "img/invite_parent_getmore.504d1347.png";